"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateProductData = exports.validateProductData = void 0;
const i18next_1 = __importDefault(require("i18next"));
const validateProductData = ({ productData, isPromiseForm, }) => {
    let validation;
    if (!productData.length) {
        validation = `${i18next_1.default.t('작품을 등록해주세요')}`;
    }
    else {
        productData.forEach(product => {
            if (!product.name || !product.name.trim()) {
                validation = `${i18next_1.default.t('작품 이름을 입력해주세요')}`;
                return false;
            }
            if (isPromiseForm && !product.origin_price) {
                validation = `${i18next_1.default.t('상품 가격을 입력해주세요')}`;
                return false;
            }
            if (product.total_order_quantity > Number(product.stock) || product.stock === 0) {
                validation = `${i18next_1.default.t('작품의 재고수량을 다시 입력해주세요')}`;
                return false;
            }
        });
    }
    return validation;
};
exports.validateProductData = validateProductData;
const generateProductData = ({ originProductData, productData, isPromiseForm, isDemandSurvey, }) => {
    if (originProductData == JSON.stringify(productData))
        return;
    let productUpdateData = productData.map(product => {
        const { id, name, stock, purchase_limit, origin_price, price, isFreeFormData } = product;
        return {
            id,
            name,
            stock: stock || 9999,
            purchase_limit: purchase_limit || 9999,
            origin_price,
            price: isDemandSurvey ? origin_price : price,
            reward_price: !isFreeFormData && isPromiseForm && origin_price !== 0 ? 250 : 0,
        };
    });
    return productUpdateData;
};
exports.generateProductData = generateProductData;
